export default {
  queryWebsiteDetailById: '/gateway/cms/faq/queryWebsiteDetailById'
}
